import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPhone = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	"aria-label": "phone source icon",
	style: { color: "#2563EB" },
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M18 6c-2 0-4 1-5 3-2 4-2 9 0 14 4 11 13 20 24 24 5 2 10 2 14 0 2-1 3-3 3-5v-7c0-2-1-3-3-4l-9-3c-2-1-4 0-5 2l-2 4c-6-3-10-7-13-13l4-2c2-1 3-3 2-5l-3-9c0-2-2-3-4-3H18z"
	})
});
export default SvgPhone;
